import { render, staticRenderFns } from "./tearmTable.vue?vue&type=template&id=7b99f221&scoped=true"
import script from "./tearmTable.vue?vue&type=script&lang=js"
export * from "./tearmTable.vue?vue&type=script&lang=js"
import style0 from "./tearmTable.vue?vue&type=style&index=0&id=7b99f221&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b99f221",
  null
  
)

export default component.exports